module.exports = __webpack_public_path__ + "static/presysVidC-b9a02ddeb11965f943d5320a2e7800dd.mp4";